import { Component, effect, HostListener, input, model, output, signal, viewChild } from '@angular/core';
import { dropDownAlignment, DropdownListComponent } from '../dropdown-list/dropdown-list.component';
import { ButtonComponent, ButtonSize, ButtonVariant } from '../button/button.component';
import { PopoverDirective, PopoverTrigger } from '../../directives/popover/popover.directive';
import { DropdownOption } from '../../models/dropdown-option.model';

@Component({
  selector: 'work-ui-dropdown-button',
  templateUrl: './actions-dropdown-button.component.html',
  styleUrls: ['./actions-dropdown-button.component.scss'],
  standalone: true,
  imports: [PopoverDirective, ButtonComponent, DropdownListComponent],
})
export class ActionsDropdownButtonComponent {
  public dropdown = viewChild<DropdownListComponent>('actionsDropdown');
  public dropdownOptions = input.required<DropdownOption[]>();
  public buttonWhiteBackground = input(false);
  public buttonSize = input<ButtonSize>('small');
  public buttonText = input('');
  public buttonVariant = input<ButtonVariant>('secondary');
  public iconName = input('more_horiz');
  public dropdownPosition = input<dropDownAlignment>('bottom');
  public tooltipDescription = input('');
  public disabled = input(false);
  public showOnHover = input(false);
  public listTitle = input('');
  public popoverTrigger = input<PopoverTrigger>('click');

  public actionSelected = output<DropdownOption>();

  public readonly dropDownOpen = model<boolean>(false);
  protected iconPositionRight = signal(true);

  private iconNameEffect = effect(() => {
    this.iconPositionRight.set(!!this.iconName());
  });

  selectAction(dropdownOption: DropdownOption) {
    this.actionSelected.emit(dropdownOption);
  }

  @HostListener('keydown', ['$event'])
  onKeyDown(event: KeyboardEvent) {
    if (this.disabled()) return;

    if (this.dropDownOpen()) {
      // When popover is open
      switch (event.key) {
        case 'Escape':
          event.preventDefault();
          event.stopPropagation();
          this.dropDownOpen.set(false);
          break;

        case 'Tab':
          // Allow tab to close and move to next element
          this.dropDownOpen.set(false);
          break;

        case 'ArrowDown':
        case 'ArrowUp':
        case 'Enter':
        case 'Home':
        case 'End':
        case 'PageUp':
        case 'PageDown':
          // Forward navigation to list component
          event.preventDefault();
          this.dropdown()?.onKeyDown(event);
          break;
      }
    } else {
      // When popover is closed
      switch (event.key) {
        case 'ArrowDown':
        case 'ArrowUp':
        case 'Enter':
          event.preventDefault();
          this.dropDownOpen.set(true);
          break;
      }
    }
  }
}
